import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { checkLoginStatus } from 'js/Api/index'; 

function PrivateRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        // First check local storage for faster response
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        if (isLoggedIn) {
          setIsAuthenticated(true);
          setIsLoading(false);
          return;
        }

        // If not in localStorage, check with the server
        const result = await checkLoginStatus();
        
        if (result.success) {
          // Check the actual isAuthenticated value in the response
          if (result.data.isAuthenticated) {
            // User is authenticated
            if (result.data.portalUserDTO) {
              localStorage.setItem('userInfo', JSON.stringify(result.data.portalUserDTO));
            }
            localStorage.setItem('isLoggedIn', 'true');
            setIsAuthenticated(true);
          } else {
            // User is not authenticated despite successful API call
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('userInfo');
            setIsAuthenticated(false);
          }
        } else {
          // API call returned an error
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('userInfo');
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Auth check error:', error);
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userInfo');
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  if (isLoading) {
    // Show loading indicator while checking auth status
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login with the current URL as a redirect parameter
    return <Navigate to={`/?redirect=${encodeURIComponent(window.location.href)}`} />;
  }

  return children;
}

export default PrivateRoute;